import Transition from '@ember/routing/-private/transition';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

import type LocalizationService from 'volta/services/localization';

export default class ApplicationRoute extends Route {
  // Services
  // ~~~~~

  @service declare localization: LocalizationService;
  @service declare intl: IntlService;

  // Lifecycle Hooks
  // ~~~~~

  async beforeModel(_transition: Transition) {
    if (!this.localization.initialTranslations) {
      const locale = this.localization.defaultLocale;
      const translations = await fetch(`/translations/${locale.value.toLowerCase()}.json`);
      this.localization.initialTranslations = await translations.json();
      this.intl.addTranslations(
        this.localization.defaultLocale.value,
        this.localization.initialTranslations
      );
      this.localization.setLocale(locale.value);
    }
  }
}
